"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsSources = exports.ReportStatus = void 0;
var ReportStatus;
(function (ReportStatus) {
    ReportStatus["IN_PROGRESS"] = "in_progress";
    ReportStatus["COMPLETED"] = "completed";
    ReportStatus["ERROR"] = "error";
    ReportStatus["DELETING"] = "deleting";
    ReportStatus["FAILED_TO_DELETE"] = "failed_to_delete";
})(ReportStatus = exports.ReportStatus || (exports.ReportStatus = {}));
var ReportsSources;
(function (ReportsSources) {
    ReportsSources["GENERATE_INVITATIONS_DRAFTS_USERS_ERRORS_CSV"] = "GENERATE_INVITATIONS_DRAFTS_USERS_ERRORS_CSV";
    ReportsSources["GENERATE_ACTIVITY_CSV_REPORT"] = "generateActivityCsvReport";
    ReportsSources["GENERATE_ASSIGNED_CONTENT_PROGRESS_CSV"] = "generateAssignedContentProgressCsv";
})(ReportsSources = exports.ReportsSources || (exports.ReportsSources = {}));
